module.exports = __webpack_public_path__ + "img/Frame-72.715dea93.svg";